import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArmyFormation, GeneralType } from "../../../../lib/types";
import ArmyBannerPerson from "./ArmyBannerPerson";
import { BANNER_NAMES, GENERAL_TYPE } from "../../../../lib/enums";
import { setSameHeight } from "../../../../lib/elementUtilities";
import { getData } from "../../../../lib/commonFunctions";
import { updateState } from "../../../../store/actions";
import { DragescentState } from "../../../../store/reducers/stateType";

interface IProps {
  tactics: number;
  activeFormationPosition?: string;
  formation?: ArmyFormation;
}

const ArmyFormationPersons = ({
  activeFormationPosition,
  formation,
  tactics
}: IProps) => {
  const divRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const [availableSoldier, setAvailableSoldier] = useState(false);
  const soldierGeneral = useSelector((state: DragescentState) => state.governorate.generals
    .find((g: GeneralType) => g.typeId === GENERAL_TYPE.SOLDIER).general);

  useEffect(() => {
    getData("/api/detail/governy/armyFormation")
      .then(formationData => dispatch(updateState({ armyFormation: formationData.armyFormation })));
  }, []);

  useEffect(() => {
    setSameHeight(divRef.current || undefined);
    setAvailableSoldier(Object.values(formation || {})
      .every(b => b?.general?.general?.id !== soldierGeneral?.id));
  }, [formation, activeFormationPosition]);

  if (!formation) {
    return <></>;
  }

  return (
    <div ref={divRef} className="row persons" id="army-formation">
      <div className="col-sm-6 col-md-3 person-col" style={{ minWidth: "fit-content" }}>
        <ArmyBannerPerson
          position={"left"}
          tactics={tactics}
          banner={formation.left}
          ownPosition={activeFormationPosition === BANNER_NAMES.LEFT_FLANK}
          availableSoldier={availableSoldier}
        />
      </div>
      <div className="col-sm-6 col-md-3 person-col" style={{ minWidth: "fit-content" }}>
        <ArmyBannerPerson
          position={"center"}
          tactics={tactics}
          banner={formation.center}
          ownPosition={activeFormationPosition === BANNER_NAMES.CENTER}
          availableSoldier={availableSoldier}
        />
      </div>
      <div className="col-sm-6 col-md-3 person-col" style={{ minWidth: "fit-content" }}>
        <ArmyBannerPerson
          position={"right"}
          tactics={tactics}
          banner={formation.right}
          ownPosition={activeFormationPosition === BANNER_NAMES.RIGHT_FLANK}
          availableSoldier={availableSoldier}
        />
      </div>
      <div className="col-sm-6 col-md-3 person-col" style={{ minWidth: "fit-content" }}>
        <ArmyBannerPerson
          position={"backup"}
          tactics={tactics}
          banner={formation.backup}
          ownPosition={activeFormationPosition === BANNER_NAMES.BACKUP}
          availableSoldier={availableSoldier}
        />
      </div>
    </div>
  )
}

export default ArmyFormationPersons;
